import type { AdminAbility } from '@repo/sdk/backoffice-abilities'

export type PermissionMode = 'all' | 'any'

export interface PermissionCheckOptions {
	mode?: PermissionMode
}

export function hasAdminAbility(
	granted: readonly string[] | null | undefined,
	required: AdminAbility[],
	options: PermissionCheckOptions = {}
) {
	// Fail closed: no abilities granted, or none requested, means denied —
	// without the length guard, mode 'all' would pass on an empty array.
	if (!(granted && required.length)) {
		return false
	}

	const grantedSet = new Set<string>(granted)
	const mode = options.mode ?? 'all'

	if (mode === 'any') {
		return required.some((ability) => grantedSet.has(ability))
	}

	return required.every((ability) => grantedSet.has(ability))
}
